<template>
    <div class="BaseErrors">
        <div class="BaseErrors__item" v-for="error in errors">
            {{error}}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseErrors',
        props: {
            //Form validation errors
            errors: {
                type: Array
            }
        }
    };
</script>

<style>
    .BaseErrors {
        min-height: 24px
    }

    .BaseErrors__item {
        font-size: .6rem;
        color: #cc4a4a;
        padding: 2px 0
    }
</style>



// WEBPACK FOOTER //
// BaseErrors.vue?c9db43e8